export const useClassroomDataStore = (userId: string, classroomId: string) => {
  return useClassroomData(userId, classroomId)();
};
